import Vue from 'vue';
import StepOne from './defaultSteps/1/StepOne';
import StepTwo from './defaultSteps/2/StepTwo';
import StepThree from './defaultSteps/3/StepThree';
import StepFour from './defaultSteps/4/StepFour';
import StepThanks from './defaultSteps/5/StepThanks';

export default {

  name: 'BookingSteps',

  provide: function () {
    return {
      currentStep: this.currentStep,
      stepValidation: this.stepValidation
    };
  },

  inject: [
    'eventsData',
    'storageData',
    'user',
    'saveStorageData'
  ],

  props: {
    step: {
      type: String,
      default: '1'
    }
  },

  components: {
    'step-one': StepOne,
    'step-two': StepTwo,
    'step-three': StepThree,
    'step-four': StepFour,
    'step-thanks': StepThanks
  },

  data () {
    return {
      currentStep: 1,
      stepValidation: {
        triedToValidateStep: false,
        isValid: true,
        isStepLoading: false
      }
    };
  },

  methods: {
    back: function () {
      this.saveStorageData();
      if (this.currentStep === 1) {
        this.$router.push('events');
      }
      this.currentStep = this.currentStep - 1;
      Vue.set(this.stepValidation, 'isValid', false);
      Vue.set(this.stepValidation, 'triedToValidateStep', false);
    },
    next: function () {
      this.saveStorageData();
      this.$emit('validateCurrentStep');

      if (this.stepValidation.isValid) {
        if (window.hasOwnProperty('parentIFrame')) {
          window.parentIFrame.scrollTo(130, 0);
        }

        this.currentStep = this.currentStep + 1;
        Vue.set(this.stepValidation, 'isValid', false);
        Vue.set(this.stepValidation, 'triedToValidateStep', false);
      }
    },

    bookingAllowed: function () {
      return this.user.userData.bookingAllowed;
    },

    checkCartData: function () {

    }
  },

  mounted: function () {
    this.currentStep = parseInt(this.step);
    let proxy = this;
    Vue.set(this.stepValidation, 'isValid', false);

    if (this.eventsData.events instanceof Promise) {
      this.eventsData.events.then(function () {
        proxy.checkCartData();
      });
    } else {
      this.checkCartData();
    }
  }

};



// WEBPACK FOOTER //
// ./src/apps/booking/components/bookingSteps/BookingSteps.js